import React from 'react';
import PropTypes from 'prop-types';

export default function ParagraphCenter({ children, className, ...props  }) {
  return (
    <p className={`text-center mb-4 ${className ? className :''}`} { ...props }>
      {children}
    </p>
  )
}

ParagraphCenter.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.element.isRequired,
    PropTypes.node.isRequired
  ]),
  className: PropTypes.string
}